// Where a browser lands when its impersonation marker no longer matches a
// session: an ordinary local sign-out, not a return to the admin area.
export const IMPERSONATION_STALE_SIGN_IN_PATH = '/auth/sign-in';

export const IMPERSONATION_EXIT_SIGN_IN_PATH =
  '/auth/sign-in?next=%2Fadmin%2Faccounts';
